const addToLog = ({ date, message, signal }) => {
    return {
        type: 'ADD_TO_LOG',
        payload: {
            date, message, signal
        }
    }
}

const getLog = () => {
    return {
        type: 'GET_LOG'
    }
}

export default { addToLog, getLog };